import { Pipe, PipeTransform } from '@angular/core';
import {
  BookingItem,
  Payment,
  TravelBookingItemMinimal,
} from '../../api/models';
import { enumPaymentMethod } from '../utils/enum-payment-method';

// es: per tirare fuori l'acconto
// booking.payments | bookingPaymentByType:'advance'
@Pipe({
  name: 'bookingPaymentByType',
})
export class BookingPaymentByTypePipe implements PipeTransform {
  transform(
    value: TravelBookingItemMinimal | BookingItem,
    ...args: ('advance' | 'payoff')[]
  ): Payment | undefined {
    return value.payments.find((p) => {
      if (args[0] === 'advance') {
        return [
          enumPaymentMethod.BANK_TRANSFER_ADV,
          enumPaymentMethod.CASH_ADV,
          enumPaymentMethod.STRIPE_ADVANCE,
        ].includes(p.type as enumPaymentMethod);
      } else {
        return [
          enumPaymentMethod.STRIPE_TRANSFER,
          enumPaymentMethod.SCALAPAY_TRANSFER,
          enumPaymentMethod.BANK_TRANSFER_PAYOFF,
          enumPaymentMethod.CASH_PAYOFF,
        ].includes(p.type as enumPaymentMethod);
      }
    });
  }
}
